import { AdminTitle } from "@/admin/AdminTitle.tsx";
import { type EntityType, entity } from "@/admin/entity.ts";
import { WModalButton } from "@/components/button/WToolButton.tsx";
import { WModal } from "@/components/modal/WModal.tsx";
import type { ReactElement, ReactNode } from "react";

export function AdminList({
    addModal,
    children,
    entityType,
}: {
    children: ReactNode;
    entityType: EntityType;
    addModal?: ReactElement;
}) {
    const m = entity[entityType];
    return (
        <>
            <AdminTitle title={m.viewTitle}>
                {addModal && (
                    <WModal button={<WModalButton label="New" color="primary" size="bar" variant="basic" />}>
                        {addModal}
                    </WModal>
                )}
            </AdminTitle>
            {children}
            {addModal && (
                <div className="p-2">
                    <WModal
                        button={
                            <WModalButton
                                className="w-full"
                                label={m.addLabel}
                                color="primary"
                                size="lg"
                                variant="dashed"
                                icon="jp-icon-add"
                            />
                        }
                    >
                        {addModal}
                    </WModal>
                </div>
            )}
        </>
    );
}
